import axios from '../axios'
export const postRole = (data) => {
  return axios({
    url: '/con/manage/role/list',
    method: 'POST',
    data
  })
}
export const addUser = (data, url) => {
  return axios({
    url: url,
    method: 'POST',
    data
  })
}
export const deleteUser = (data) => {
  return axios({
    url: '/con/manage/role/delete',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/http/moudules/role.js